import { StringColumn, NumericalColumn } from 'baseui/data-table';
import { EMPTY_STRING, EMPTY_NUMBER } from 'commons-ui';

export const COL_NAMES = {
	drawId: 'drawId',
	zuid: 'zuid',
	numberOfWinningTickets: 'numberOfWinningTickets',
	zuidWinningRewards: 'zuidWinningRewards',
	numberOfTickets: 'numberOfTickets'
};

export const columnConfigs = [
	NumericalColumn({
		title: 'Draw Id',
		mapDataToValue: (data: any) => data[COL_NAMES.drawId] || EMPTY_NUMBER
	}),
	StringColumn({
		title: 'Zupee User Id',
		mapDataToValue: (data: any) => data[COL_NAMES.zuid] || EMPTY_STRING
	}),
	NumericalColumn({
		title: 'Number of Winning Tickets',
		minWidth: 100,
		mapDataToValue: (data: any) => data[COL_NAMES.numberOfWinningTickets] || EMPTY_NUMBER
	}),
	NumericalColumn({
		title: 'Zupee Winning Rewards',
		minWidth: 100,
		mapDataToValue: (data: any) => data[COL_NAMES.zuidWinningRewards] || EMPTY_NUMBER
	}),
	NumericalColumn({
		title: 'Number of Tickets',
		minWidth: 100,
		mapDataToValue: (data: any) => data[COL_NAMES.numberOfTickets] || EMPTY_NUMBER
	})
];
